import React, { Component, cloneElement,useState } from 'react';
import { List, CreateButton, SelectInput, ReferenceInput, RefreshButton, TopToolbar, Datagrid,DateTimeInput, TextField, DateField, ShowButton, Filter,usePermissions,useResourceContext, TextInput, EditButton, ExportButton, Link , Button ,useRecordContext ,DateInput, TimeInput } from 'react-admin';
// import { DateInput, TimeInput } from 'react-admin-date-inputs';
// import { Accordion } from '@mui/material';
import { Scrollbars } from 'react-custom-scrollbars';
import moment from 'moment';
import Modal from 'react-responsive-modal';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from '../common/common';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';
import GetAppIcon from '@mui/icons-material/GetApp';

const Filters = (props) => (
    <Filter {...props}>
        <TextInput label="Popup Text" source="popup_text" />
        <TextInput label="Survey Type" source="survey_type" />
        <ReferenceInput label="Targeted Feature" source="survey_targeted_feature_id" reference="survey_targeted_features">
            <SelectInput optionText="targeted_feature" />
        </ReferenceInput>
        <DateTimeInput
          source="start_date"
          label="Start date"
          showTime
        />
        <DateTimeInput
          source="end_date"
          label="End date"
          showTime
        />
        {/* <DateInput label="Start date" source="start_date" /> */}
        {/* <DateInput label="End date" source="end_date" /> */}
        {/* <TimeInput label="Start Time" source="start_time" /> */}
        {/* <TimeInput label="End Time" source="end_time" /> */}
    </Filter>
);

// const TopToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const textFieldStyle = {
    display: 'block',
    width: 200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

};

// const ListActions = ({ resource, basePath, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters }) => {
//     // const { resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters } = this.props;
//     const csvResource = resource + '_csv'
//     return (
//         <TopToolbar>
//             {filters && cloneElement(filters, {
//                 resource,
//                 showFilter,
//                 displayedFilters,
//                 filterValues,
//                 context: 'button',
//             })}
//             <ExportButton
//                 onClick={(e) => callExport(e)}
//                 disabled={total === 0}
//                 resource={csvResource}
//                 sort={currentSort}
//                 filter={{ ...filterValues, ...permanentFilter }}
//                 exporter={ () => {return ''}}
//                 maxResults={maxResults}
//             />
//             <CreateButton basePath={basePath} />
//             <RefreshButton />
//         </TopToolbar>
//     )
// }

// class ListActions extends Component {
//     constructor(props){
      
//       super(props);
//       this.state = {
//         modalShow : false,
//         modalMsg : '',
//         customFilterUrl : 'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D',
//       }
//     }
    
//     callExport = (e) => {
//       const options = CommonHeaderOption();
//       const apiUrl = RUN_TIME_API_ENDPOINT;
//       e.preventDefault();
//       console.log('...', window.location.href, `${apiUrl}/${this.props.resource}_csv`)
//       options.method = 'GET';
//       let _url = window.location.href.split('?');
//       if (_url.length > 1 && _url[1] !== '') {
//         console.log('params found');
//         this.setState({customFilterUrl : _url[1]}, ()=>{
//           fetch(`${apiUrl}/${this.props.resource}_csv?${this.state.customFilterUrl}`, options)
//             .then(res => {
//                 return res.json();
//             }).then(jsonD => {
//               console.log('json= inside callback', jsonD.data);
//               const msg = jsonD.data[0].message;
//               Swal.fire({
//                   html: msg,
//                   icon: 'success',
//               })
//               // this.setState({ modalShow: true});
//               // this.setState({ modalMsg: msg});
//           });
//         })
//       } else {
//         this.setState({customFilterUrl : 'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D' }, ()=>{
//           fetch(`${apiUrl}/${this.props.resource}_csv?${this.state.customFilterUrl}`, options)
//             .then(res => {
//                 return res.json();
//             }).then(jsonD => {
//               console.log('json= inside callback', jsonD.data);
//               const msg = jsonD.data[0].message;
//               Swal.fire({
//                   html: msg,
//                   icon: 'success',
//               })
//               // this.setState({ modalShow: true});
//               // this.setState({ modalMsg: msg});
//           });
//         })
//       }
//     }
//     exporterModal = () => {
//       return ''
//     }
  
//     onClose = () => {
//       this.setState({ modalShow: false})
//     }
//     render(){
//       const { resource, filterValues, total, basePath, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters } = this.props;
//       const csvResource = resource + '_csv'
//     return (
//       <React.Fragment>
//       <TopToolbar>
//         {filters && cloneElement(filters, {
//           resource,
//           showFilter,
//           displayedFilters,
//           filterValues,
//           context: 'button',
//         })}
//         <RefreshButton />
//         <CreateButton basePath={basePath} />
//         {/* <ExportButton
//           onClick={(e) => this.callExport(e)}
//           disabled={total === 0}
//           resource={csvResource}
//           sort={currentSort}
//           filter={{ ...filterValues, ...permanentFilter }}
//           exporter={this.exporterModal}
//           maxResults={maxResults}
//           /> */}
//           {/* <div>
//             <button className="export-button"
//               onClick={(e) => this.callExport(e)}
//               disabled={total === 0}
//               sort={currentSort}
//               filter={{ ...filterValues, ...permanentFilter }}
//             >
//               {<GetAppIcon />}
//               <span>Export</span>
//             </button>
//           </div>           */}
//       </TopToolbar>
//       {
//             this.state.modalShow &&
//             <Modal open={this.state.modalShow} onClose={this.onClose} center> 
//               <h3>{this.state.modalMsg}</h3>
//             </Modal>
//       }
//       </React.Fragment>
//     )
//     }
// }

const ListActions = (props) => {

  const location = useLocation();
  const resource = useResourceContext();

  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [customFilterUrl, setCustomFilterUrl] = useState(
    location.search
    );


  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log('...', location.pathname, `${apiUrl}/${resource}_csv`)
    options.method = 'GET';
    let _url = location.pathname.split('?');
    if (_url.length > 1 && _url[1] !== '') {
      console.log('params found');
     setCustomFilterUrl(_url[1]);
      fetch(`${apiUrl}/${resource}_csv?${_url[1]}`, options)
          .then(res => {
            return res.json();
          }).then(jsonD => {
            console.log('json= inside callback', jsonD.data);
            const msg = jsonD.data ? jsonD.data[0].message : '';
            Swal.fire({
              html: msg,
              icon: 'success',
            })
            // this.setState({ modalShow: true});
            // this.setState({ modalMsg: msg});
          });
    } else {
      setCustomFilterUrl(location.search)
      fetch(`${apiUrl}/${resource}_csv?${location.search}`, options)
          .then(res => {
            return res.json();
          }).then(jsonD => {
            console.log('json= inside callback', jsonD.data);
            const msg = jsonD.data ? jsonD.data[0].message : '';
            Swal.fire({
              html: msg,
              icon: 'success',
            })
            // this.setState({ modalShow: true});
            // this.setState({ modalMsg: msg});
          });
    }
  }
  const exporterModal = () => {
    return ''
  }

  const onClose = () => {
    setModalShow(false);
  }
    const { filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters } = props;
    const csvResource = resource + '_csv'
    return (
      <React.Fragment>
        <TopToolbar>
          {filters && cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
          })}
          <RefreshButton />
          {/* <ExportButton
        onClick={(e) => this.callExport(e)}
        disabled={total === 0}
        resource={csvResource}
        sort={currentSort}
        filter={{ ...filterValues, ...permanentFilter }}
        exporter={this.exporterModal}
        maxResults={maxResults}
        /> */}
          <div>
            <button className="export-button"
              onClick={(e) => callExport(e)}
              disabled={total === 0}
              sort={currentSort}
              filter={{ ...filterValues, ...permanentFilter }}
            >
              {<GetAppIcon />}
              <span>Export</span>
            </button>
          </div>
          <CreateButton />
        </TopToolbar>
        {
          modalShow &&
          <Modal open={modalShow} onClose={onClose} center>
            <h3>{modalMsg}</h3>
          </Modal>
        }
      </React.Fragment>
    )
}

const TimeComponent = (props) => {
  const record = useRecordContext();
    return (
        <span>
            {moment(record[props.source]).format('HH:mm:ss')}
        </span>
    );
}


// const callExport = (e) => {
//     const options = CommonHeaderOption();
//     const apiUrl = RUN_TIME_API_ENDPOINT;
//     e.preventDefault();
//     console.log('...', window.location.href, `${apiUrl}/surveys_csv`)
//     options.method = 'GET';
//     let _url = window.location.href.split('?');
//     if (_url.length > 1 && _url[1] !== '') {
//       console.log('params found');
//       this.setState({customFilterUrl : _url[1]}, ()=>{
//         fetch(`${apiUrl}/${this.props.resource}_csv?${this.state.customFilterUrl}`, options)
//           .then(res => {
//               return res.json();
//           }).then(jsonD => {
//             console.log('json= inside callback', jsonD.data);
//             const msg = jsonD.data[0].message;
//             this.setState({ modalShow: true});
//             this.setState({ modalMsg: msg});
//         });
//       })
//     } else {
//       this.setState({customFilterUrl : 'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D' }, ()=>{
//         fetch(`${apiUrl}/${this.props.resource}_csv?${this.state.customFilterUrl}`, options)
//           .then(res => {
//               return res.json();
//           }).then(jsonD => {
//             console.log('json= inside callback', jsonD.data);
//             const msg = jsonD.data[0].message;
//             this.setState({ modalShow: true});
//             this.setState({ modalMsg: msg});
//         });
//       })
//     }
// }

const CloneSurveyButton = () => 
    {
      const record = useRecordContext();
      return(
        <Button
            component={Link}
            to={{
                pathname: '/surveys/create',
                search: `?source=%7B"id"%3A"${record.id}"%2C"total_count"%3A1%7D`,
            }}
            onClick={e=>e.stopPropagation()}
        >
            <span>{<FileCopyIcon className="clone-img" />}<span className="clone-text">Duplicate</span></span> 
        </Button>

      )
    };

const SurveysList = (props) => {
  const { permissions } = usePermissions();
  const record = useRecordContext()

    return (
        <React.Fragment>
            <Scrollbars className="scroll-container" >
                <List {...props} sort={{ field: 'created_at', order: 'DESC' }} filters={<Filters />} title="Survey" 
                actions={<ListActions  props={props} />}
                >
                    <Datagrid rowClick="show"  bulkActionButtons={false}>
                        <EditButton />
                        <TextField label="Purpose" source="purpose" style={textFieldStyle} allowEmpty />
                        <TextField label="Popup Text" source="popup_text" style={textFieldStyle} allowEmpty />
                        <TextField label="Targeted Feature" source="targeted_feature" style={textFieldStyle} allowEmpty />
                        <TextField label="Survey Type" source="survey_type" style={textFieldStyle} allowEmpty />
                        <DateField label="Start date" source="start_date" />
                        <DateField label="End date" source="end_date" />
                        <TextField label="Start Time" source="start_time" style={textFieldStyle} allowEmpty />
                        <TextField label="End Time" source="end_time" style={textFieldStyle} allowEmpty />
                        {/* <TimeComponent label="Start Time" source="start_time" default="-" />
                        <TimeComponent label="End Time" source="end_time" default="-" /> */}
                        <DateField source="created_at" showTime />
                        <DateField source="updated_at" showTime />
                        <CloneSurveyButton/>
                        <ShowButton />
                    </Datagrid>
                </List>
            </Scrollbars>
        </React.Fragment>
    )
}


export default SurveysList;